import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import * as routes from 'constants/routes';

import withRoute from '../hocs/withRoute';

import LoginForm from './landing/LoginForm';
import SigninForm from './landing/SigninForm';
import PasswordReset from './landing/PasswordReset';
import PasswordRecovery from './landing/PasswordRecovery';

import Profile from './profile/Profile';
import Bonus from './bonus/Bonus';

import Projects from './projects/Projects';

import ProjectAdd from './projects/project/ProjectAdd';
import ProjectView from './projects/project/ProjectView';
import ProjectEdit from './projects/project/ProjectEdit';

import ProjectApplicationView from './projects/application/ProjectApplicationView';
import ProjectApplicationAdd from './projects/application/ProjectApplicationAdd';
import ProjectApplicationEdit from './projects/application/ProjectApplicationEdit'

import Notifications from './notifications/Notifications';
import {deleteCookie, getCookie} from "utils/cookie";
import EmailVerification from './verification/EmailVerification';
import { Products } from './products/Products';
import { Mainpage } from './mainpage/Mainpage';

const MainRedirect = () => <Redirect to={routes.main.path} />

const LastPageRedirect = () => {
        const redirect = <Redirect to={getCookie('last_page') || routes.main.path}/>;

        deleteCookie('last_page');

        return redirect;
};

export const GuestRoutes = () => (
    <Switch>
        <Route path={routes.login.path} component={() => null} />
        <Route path={routes.signin.path} component={() => null} />
        <Route path={routes.password_reset.path} component={() => null} />
        <Route pah={routes.password_recovery.path} component={() => null} />
    </Switch>
);

export const GuestAuthorizationRoutes = () => (
    <Switch>
        <Route path={routes.email_verification.path} component={EmailVerification} exact/> 
        <Route path={routes.login.path} component={LoginForm} />
        <Route path={routes.signin.path} component={SigninForm} />
        <Route path={routes.password_reset.path} component={PasswordReset} />
        <Route path={routes.password_recovery.path} component={PasswordRecovery}/>
        <Route component={MainRedirect}/>
    </Switch>
);

export const UserRoutes = ({ confirmed }) => (
    confirmed ? 
    <Switch>
        <Route path={routes.profile.path} component={withRoute(Profile)} exact />

        <Route path={routes.bonus.path} component={withRoute(Bonus)} />
        <Route path={routes.products.path} component={withRoute(Products)}/>
        <Route path={routes.projects.stringify()} component={withRoute(Projects)} exact />
        <Route path={routes.project_add.path} component={withRoute(ProjectAdd)} />
        <Route path={routes.project_edit.path} component={withRoute(ProjectEdit)} />
        <Route path={routes.project_application_add.path} component={withRoute(ProjectApplicationAdd)} />
        <Route path={routes.project_application_edit.path} component={withRoute(ProjectApplicationEdit)} />
        <Route path={routes.project_application.path} component={withRoute(ProjectApplicationView)} />
        <Route path={routes.project_show.path} component={withRoute(ProjectView)} />
        <Route path={routes.notifications.path} component={withRoute(Notifications)} />
        <Route path={routes.main.path} component={withRoute(Mainpage)}/>
        <Route component={LastPageRedirect} />
    </Switch> 
    :
    <Switch>
        <Route path={routes.main.path} component={withRoute(Mainpage)} exact/>
        <Route path={routes.profile.path} component={withRoute(Profile)}/>
        <Route path={routes.notifications.path} component={withRoute(Notifications)} />
        <Route render={({ location })=> <Redirect to={{ pathname:  routes.profile.path, state: { from: location}}}/>}/>
    </Switch>
);



// WEBPACK FOOTER //
// ./src/components/pages/Routes.js